export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.8-0802.18",
  commitId: "c829e5653a018ba63d1c43af60d77fa24a3a85b7",
  commitTime: "2026-10-08T08:02:18.000Z",
});
